import React from "react";
import "../../App.css";
import SideBar from "../layout/sidebar/Sidebar";
import DashboardNavBar from "../layout/DashboardNavBar";
import EditProject from "./EditProject";

const EditProfileCall = ({ match }) => {
  return (
    <div>
      <DashboardNavBar />
      <SideBar />
      <EditProject id={match.params.id} mode={match.params.mode}/>
    </div>
  );
}

export default EditProfileCall;